import React from 'react'
import moment from 'moment'
import * as _ from 'underscore'
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ReferenceLine, ResponsiveContainer } from 'recharts'

type Props = {
  data: Object
}

type State = {
  zurich: string[],
  berne: string[],
  basel: string[],
  data: string[],
  activeLine: number,
  dataReady: boolean
}

const staticData = [
  {
    'date': '2018-12-21 14:00:00',
    'datum': 1545397200000,
    'ZH': 6.22,
    'BS': 3.466,
    'BE': 0.776
  },
  {
    'date': '2018-12-21 15:00:00',
    'datum': 1545400800000,
    'ZH': 5.42,
    'BS': 3.393,
    'BE': 8.253
  },
  {
    'date': '2018-12-21 16:00:00',
    'datum': 1545404400000,
    'ZH': 4.95,
    'BS': 3.834,
    'BE': 2.959
  },
  {
    'date': '2018-12-21 17:00:00',
    'datum': 1545408000000,
    'ZH': 4.65,
    'BS': 4.485,
    'BE': 0.191
  },
  {
    'date': '2018-12-21 18:00:00',
    'datum': 1545411600000,
    'ZH': 5.03,
    'BS': 4.885,
    'BE': 0.05
  },
  {
    'date': '2018-12-21 19:00:00',
    'datum': 1545415200000,
    'ZH': 4.97,
    'BS': 5.919,
    'BE': 4.629
  },
  {
    'date': '2018-12-21 20:00:00',
    'datum': 1545418800000,
    'ZH': 6.07,
    'BS': 8.089,
    'BE': 7.147
  },
  {
    'date': '2018-12-21 21:00:00',
    'datum': 1545422400000,
    'ZH': 6.47,
    'BS': 8.997,
    'BE': 6.665
  },
  {
    'date': '2018-12-21 22:00:00',
    'datum': 1545426000000,
    'ZH': 5.96,
    'BS': 5.993,
    'BE': 8.116
  },
  {
    'date': '2018-12-21 23:00:00',
    'datum': 1545429600000,
    'ZH': 4.89,
    'BS': 3.22,
    'BE': 2.943
  },
  {
    'date': '2018-12-22 00:00:00',
    'datum': 1545433200000,
    'ZH': 4.98,
    'BS': 2.947,
    'BE': 0.176
  },
  {
    'date': '2018-12-22 01:00:00',
    'datum': 1545436800000,
    'ZH': 4.18,
    'BS': 2.661,
    'BE': 3.989
  },
  {
    'date': '2018-12-22 02:00:00',
    'datum': 1545440400000,
    'ZH': 3.81,
    'BS': 2.823,
    'BE': 15.63
  },
  {
    'date': '2018-12-22 03:00:00',
    'datum': 1545444000000,
    'ZH': 3.91,
    'BS': 3.065,
    'BE': 4.189
  },
  {
    'date': '2018-12-22 04:00:00',
    'datum': 1545447600000,
    'ZH': 3.82,
    'BS': 2.852,
    'BE': 1.073
  },
  {
    'date': '2018-12-22 05:00:00',
    'datum': 1545451200000,
    'ZH': 4.03,
    'BS': 3.111,
    'BE': null
  },
  {
    'date': '2018-12-22 06:00:00',
    'datum': 1545454800000,
    'ZH': 3.94,
    'BS': 3.218,
    'BE': null
  },
  {
    'date': '2018-12-22 07:00:00',
    'datum': 1545458400000,
    'ZH': 4.2,
    'BS': 3.296,
    'BE': 0.212
  },
  {
    'date': '2018-12-22 08:00:00',
    'datum': 1545462000000,
    'ZH': 4.38,
    'BS': 3.611,
    'BE': 0.356
  },
  {
    'date': '2018-12-22 09:00:00',
    'datum': 1545465600000,
    'ZH': 4.65,
    'BS': 4.535,
    'BE': null
  },
  {
    'date': '2018-12-22 10:00:00',
    'datum': 1545469200000,
    'ZH': 4.58,
    'BS': 4.431,
    'BE': 0.104
  },
  {
    'date': '2018-12-22 11:00:00',
    'datum': 1545472800000,
    'ZH': 4.68,
    'BS': 4.229,
    'BE': 2.229
  },
  {
    'date': '2018-12-22 12:00:00',
    'datum': 1545476400000,
    'ZH': 4.36,
    'BS': 5.533,
    'BE': 1.363
  },
  {
    'date': '2018-12-22 13:00:00',
    'datum': 1545480000000,
    'ZH': 4.51,
    'BS': 5.932,
    'BE': 0
  },
  {
    'date': '2018-12-22 14:00:00',
    'datum': 1545483600000,
    'ZH': 4.65,
    'BS': 6.816,
    'BE': 2.087
  },
  {
    'date': '2018-12-22 15:00:00',
    'datum': 1545487200000,
    'ZH': 4.84,
    'BS': 6.979,
    'BE': null
  },
  {
    'date': '2018-12-22 16:00:00',
    'datum': 1545490800000,
    'ZH': 4.66,
    'BS': 6.963,
    'BE': null
  },
  {
    'date': '2018-12-22 17:00:00',
    'datum': 1545494400000,
    'ZH': 4.98,
    'BS': 7.194,
    'BE': 0
  },
  {
    'date': '2018-12-22 18:00:00',
    'datum': 1545498000000,
    'ZH': 5.91,
    'BS': 6.9,
    'BE': 0.601
  },
  {
    'date': '2018-12-22 19:00:00',
    'datum': 1545501600000,
    'ZH': 6.18,
    'BS': 6.706,
    'BE': 3.852
  },
  {
    'date': '2018-12-22 20:00:00',
    'datum': 1545505200000,
    'ZH': 6.79,
    'BS': 7.471,
    'BE': 3.599
  },
  {
    'date': '2018-12-22 21:00:00',
    'datum': 1545508800000,
    'ZH': 7.09,
    'BS': 7.589,
    'BE': 0.364
  },
  {
    'date': '2018-12-22 22:00:00',
    'datum': 1545512400000,
    'ZH': 7.24,
    'BS': 8.057,
    'BE': 4.439
  },
  {
    'date': '2018-12-22 23:00:00',
    'datum': 1545516000000,
    'ZH': 7.32,
    'BS': 7.314,
    'BE': 0.888
  },
  {
    'date': '2018-12-23 00:00:00',
    'datum': 1545519600000,
    'ZH': 7.02,
    'BS': 7.738,
    'BE': 0
  },
  {
    'date': '2018-12-23 01:00:00',
    'datum': 1545523200000,
    'ZH': 6.59,
    'BS': 8.279,
    'BE': 0.451
  },
  {
    'date': '2018-12-23 02:00:00',
    'datum': 1545526800000,
    'ZH': 6.15,
    'BS': 8.85,
    'BE': 0
  },
  {
    'date': '2018-12-23 03:00:00',
    'datum': 1545530400000,
    'ZH': 5.53,
    'BS': 8.562,
    'BE': 1.348
  },
  {
    'date': '2018-12-23 04:00:00',
    'datum': 1545534000000,
    'ZH': 5.18,
    'BS': 8.741,
    'BE': 3.939
  },
  {
    'date': '2018-12-23 05:00:00',
    'datum': 1545537600000,
    'ZH': 5.52,
    'BS': 8.643,
    'BE': 1.569
  },
  {
    'date': '2018-12-23 06:00:00',
    'datum': 1545541200000,
    'ZH': 5.46,
    'BS': 8.481,
    'BE': 1.875
  },
  {
    'date': '2018-12-23 07:00:00',
    'datum': 1545544800000,
    'ZH': 5.66,
    'BS': 8.545,
    'BE': 0.589
  },
  {
    'date': '2018-12-23 08:00:00',
    'datum': 1545548400000,
    'ZH': 6.32,
    'BS': 7.956,
    'BE': 1.912
  },
  {
    'date': '2018-12-23 09:00:00',
    'datum': 1545552000000,
    'ZH': 6.79,
    'BS': 8.546,
    'BE': 2.515
  },
  {
    'date': '2018-12-23 10:00:00',
    'datum': 1545555600000,
    'ZH': 7.06,
    'BS': 9.684,
    'BE': 3.094
  },
  {
    'date': '2018-12-23 11:00:00',
    'datum': 1545559200000,
    'ZH': 7.05,
    'BS': 10.065,
    'BE': 3.505
  },
  {
    'date': '2018-12-23 12:00:00',
    'datum': 1545562800000,
    'ZH': 7.74,
    'BS': 9.522,
    'BE': 3.669
  },
  {
    'date': '2018-12-23 13:00:00',
    'datum': 1545566400000,
    'ZH': 6.06,
    'BS': 10.76,
    'BE': 1.358
  },
  {
    'date': '2018-12-23 14:00:00',
    'datum': 1545570000000,
    'ZH': 6.58,
    'BS': 11.021,
    'BE': 5.926
  },
  {
    'date': '2018-12-23 15:00:00',
    'datum': 1545573600000,
    'ZH': 7.52,
    'BS': 9.679,
    'BE': 2.849
  },
  {
    'date': '2018-12-23 16:00:00',
    'datum': 1545577200000,
    'ZH': 5.71,
    'BS': 6.742,
    'BE': 0.363
  },
  {
    'date': '2018-12-23 17:00:00',
    'datum': 1545580800000,
    'ZH': 7.24,
    'BS': 3.558,
    'BE': 0
  },
  {
    'date': '2018-12-23 18:00:00',
    'datum': 1545584400000,
    'ZH': 5.43,
    'BS': 3.39,
    'BE': 2.709
  },
  {
    'date': '2018-12-23 19:00:00',
    'datum': 1545588000000,
    'ZH': 5.01,
    'BS': 3.037,
    'BE': 1.356
  },
  {
    'date': '2018-12-23 20:00:00',
    'datum': 1545591600000,
    'ZH': 4.29,
    'BS': 2.934,
    'BE': null
  },
  {
    'date': '2018-12-23 21:00:00',
    'datum': 1545595200000,
    'ZH': 4.16,
    'BS': 3.016,
    'BE': 0.036
  },
  {
    'date': '2018-12-23 22:00:00',
    'datum': 1545598800000,
    'ZH': 3.98,
    'BS': 2.99,
    'BE': 0
  },
  {
    'date': '2018-12-23 23:00:00',
    'datum': 1545602400000,
    'ZH': 3.91,
    'BS': 2.888,
    'BE': 0.944
  },
  {
    'date': '2018-12-24 00:00:00',
    'datum': 1545606000000,
    'ZH': 4.06,
    'BS': 2.89,
    'BE': null
  },
  {
    'date': '2018-12-24 01:00:00',
    'datum': 1545609600000,
    'ZH': 3.72,
    'BS': 2.825,
    'BE': 0.104
  },
  {
    'date': '2018-12-24 02:00:00',
    'datum': 1545613200000,
    'ZH': 3.74,
    'BS': 2.761,
    'BE': null
  },
  {
    'date': '2018-12-24 03:00:00',
    'datum': 1545616800000,
    'ZH': 3.77,
    'BS': 2.937,
    'BE': null
  },
  {
    'date': '2018-12-24 04:00:00',
    'datum': 1545620400000,
    'ZH': 3.51,
    'BS': 2.831,
    'BE': null
  },
  {
    'date': '2018-12-24 05:00:00',
    'datum': 1545624000000,
    'ZH': 3.53,
    'BS': 3.226,
    'BE': 0
  },
  {
    'date': '2018-12-24 06:00:00',
    'datum': 1545627600000,
    'ZH': 3.58,
    'BS': 3.001,
    'BE': null
  },
  {
    'date': '2018-12-24 07:00:00',
    'datum': 1545631200000,
    'ZH': 3.83,
    'BS': 3.039,
    'BE': 0
  },
  {
    'date': '2018-12-24 08:00:00',
    'datum': 1545634800000,
    'ZH': 3.78,
    'BS': 3.489,
    'BE': null
  },
  {
    'date': '2018-12-24 09:00:00',
    'datum': 1545638400000,
    'ZH': 4.17,
    'BS': 3.447,
    'BE': null
  },
  {
    'date': '2018-12-24 10:00:00',
    'datum': 1545642000000,
    'ZH': 4.2,
    'BS': 3.475,
    'BE': 2.024
  },
  {
    'date': '2018-12-24 11:00:00',
    'datum': 1545645600000,
    'ZH': 4.39,
    'BS': 4.305,
    'BE': 0.233
  },
  {
    'date': '2018-12-24 12:00:00',
    'datum': 1545649200000,
    'ZH': 5.06,
    'BS': 3.941,
    'BE': 0
  },
  {
    'date': '2018-12-24 13:00:00',
    'datum': 1545652800000,
    'ZH': 5.58,
    'BS': 4.079,
    'BE': 0.545
  },
  {
    'date': '2018-12-24 14:00:00',
    'datum': 1545656400000,
    'ZH': 5.64,
    'BS': 4.3,
    'BE': null
  },
  {
    'date': '2018-12-24 15:00:00',
    'datum': 1545660000000,
    'ZH': 5.68,
    'BS': 4.906,
    'BE': null
  },
  {
    'date': '2018-12-24 16:00:00',
    'datum': 1545663600000,
    'ZH': 6.41,
    'BS': 5.938,
    'BE': null
  },
  {
    'date': '2018-12-24 17:00:00',
    'datum': 1545667200000,
    'ZH': 7.13,
    'BS': 5.791,
    'BE': 0
  },
  {
    'date': '2018-12-24 18:00:00',
    'datum': 1545670800000,
    'ZH': 7.63,
    'BS': 6.549,
    'BE': 1.76
  },
  {
    'date': '2018-12-24 19:00:00',
    'datum': 1545674400000,
    'ZH': 11.18,
    'BS': 8.697,
    'BE': 6.348
  },
  {
    'date': '2018-12-24 20:00:00',
    'datum': 1545678000000,
    'ZH': 10.46,
    'BS': 10.837,
    'BE': 9.13
  },
  {
    'date': '2018-12-24 21:00:00',
    'datum': 1545681600000,
    'ZH': 9.61,
    'BS': 11.668,
    'BE': 11.3
  },
  {
    'date': '2018-12-24 22:00:00',
    'datum': 1545685200000,
    'ZH': 10.73,
    'BS': 10.933,
    'BE': 9.852
  },
  {
    'date': '2018-12-24 23:00:00',
    'datum': 1545688800000,
    'ZH': 12.58,
    'BS': 12.67,
    'BE': 11.146
  },
  {
    'date': '2018-12-25 00:00:00',
    'datum': 1545692400000,
    'ZH': 11.85,
    'BS': 14.98,
    'BE': 10.16
  },
  {
    'date': '2018-12-25 01:00:00',
    'datum': 1545696000000,
    'ZH': 11.65,
    'BS': 17.098,
    'BE': 10.76
  },
  {
    'date': '2018-12-25 02:00:00',
    'datum': 1545699600000,
    'ZH': 12,
    'BS': 15.671,
    'BE': 10.701
  },
  {
    'date': '2018-12-25 03:00:00',
    'datum': 1545703200000,
    'ZH': 12.45,
    'BS': 12.219,
    'BE': 9.223
  },
  {
    'date': '2018-12-25 04:00:00',
    'datum': 1545706800000,
    'ZH': 12.7,
    'BS': 15.022,
    'BE': 6.197
  },
  {
    'date': '2018-12-25 05:00:00',
    'datum': 1545710400000,
    'ZH': 13.15,
    'BS': 14.506,
    'BE': 7.185
  },
  {
    'date': '2018-12-25 06:00:00',
    'datum': 1545714000000,
    'ZH': 14.09,
    'BS': 15.712,
    'BE': 3.463
  },
  {
    'date': '2018-12-25 07:00:00',
    'datum': 1545717600000,
    'ZH': 13.13,
    'BS': 17.179,
    'BE': 4.541
  },
  {
    'date': '2018-12-25 08:00:00',
    'datum': 1545721200000,
    'ZH': 13.02,
    'BS': 19.379,
    'BE': 7.56
  },
  {
    'date': '2018-12-25 09:00:00',
    'datum': 1545724800000,
    'ZH': 14.72,
    'BS': 19.532,
    'BE': 7.239
  },
  {
    'date': '2018-12-25 10:00:00',
    'datum': 1545728400000,
    'ZH': 16.12,
    'BS': 12.898,
    'BE': 6.376
  },
  {
    'date': '2018-12-25 11:00:00',
    'datum': 1545732000000,
    'ZH': 15.12,
    'BS': 9.829,
    'BE': 7.358
  },
  {
    'date': '2018-12-25 12:00:00',
    'datum': 1545735600000,
    'ZH': 14.26,
    'BS': 10.467,
    'BE': 9.238
  },
  {
    'date': '2018-12-25 13:00:00',
    'datum': 1545739200000,
    'ZH': 16.62,
    'BS': 10.924,
    'BE': 10.77
  },
  {
    'date': '2018-12-25 14:00:00',
    'datum': 1545742800000,
    'ZH': 17.73,
    'BS': 10.077,
    'BE': 7.59
  },
  {
    'date': '2018-12-25 15:00:00',
    'datum': 1545746400000,
    'ZH': 18.29,
    'BS': 9.668,
    'BE': 7.98
  },
  {
    'date': '2018-12-25 16:00:00',
    'datum': 1545750000000,
    'ZH': 18.85,
    'BS': 10.977,
    'BE': 7.287
  },
  {
    'date': '2018-12-25 17:00:00',
    'datum': 1545753600000,
    'ZH': 19.69,
    'BS': 12.949,
    'BE': 8.021
  },
  {
    'date': '2018-12-25 18:00:00',
    'datum': 1545757200000,
    'ZH': 15.63,
    'BS': 12.567,
    'BE': 7.5
  },
  {
    'date': '2018-12-25 19:00:00',
    'datum': 1545760800000,
    'ZH': 17.15,
    'BS': 14.083,
    'BE': 6.226
  },
  {
    'date': '2018-12-25 20:00:00',
    'datum': 1545764400000,
    'ZH': 16.09,
    'BS': 14.904,
    'BE': 5.876
  },
  {
    'date': '2018-12-25 21:00:00',
    'datum': 1545768000000,
    'ZH': 15.3,
    'BS': 14.722,
    'BE': 8.528
  },
  {
    'date': '2018-12-25 22:00:00',
    'datum': 1545771600000,
    'ZH': 15.17,
    'BS': 14.052,
    'BE': 9.881
  },
  {
    'date': '2018-12-25 23:00:00',
    'datum': 1545775200000,
    'ZH': 16.14,
    'BS': 14.171,
    'BE': 9.4
  },
  {
    'date': '2018-12-26 00:00:00',
    'datum': 1545778800000,
    'ZH': 17.19,
    'BS': 14.47,
    'BE': 8.608
  },
  {
    'date': '2018-12-26 01:00:00',
    'datum': 1545782400000,
    'ZH': 18.03,
    'BS': 13.582,
    'BE': 11.74
  },
  {
    'date': '2018-12-26 02:00:00',
    'datum': 1545786000000,
    'ZH': 18.42,
    'BS': 14.46,
    'BE': 12.405
  },
  {
    'date': '2018-12-26 03:00:00',
    'datum': 1545789600000,
    'ZH': 17.97,
    'BS': 14.334,
    'BE': 12.148
  },
  {
    'date': '2018-12-26 04:00:00',
    'datum': 1545793200000,
    'ZH': 18.48,
    'BS': 14.54,
    'BE': 10.825
  },
  {
    'date': '2018-12-26 05:00:00',
    'datum': 1545796800000,
    'ZH': 20.83,
    'BS': 14.315,
    'BE': 13.783
  },
  {
    'date': '2018-12-26 06:00:00',
    'datum': 1545800400000,
    'ZH': 22.13,
    'BS': 14.441,
    'BE': 14.592
  },
  {
    'date': '2018-12-26 07:00:00',
    'datum': 1545804000000,
    'ZH': 21.54,
    'BS': 14.985,
    'BE': 10.3
  },
  {
    'date': '2018-12-26 08:00:00',
    'datum': 1545807600000,
    'ZH': 20.55,
    'BS': 15.442,
    'BE': 14.012
  },
  {
    'date': '2018-12-26 09:00:00',
    'datum': 1545811200000,
    'ZH': 20.4,
    'BS': 16.991,
    'BE': 14.125
  },
  {
    'date': '2018-12-26 10:00:00',
    'datum': 1545814800000,
    'ZH': 20.94,
    'BS': 14.934,
    'BE': 12.46
  },
  {
    'date': '2018-12-26 11:00:00',
    'datum': 1545818400000,
    'ZH': 22.39,
    'BS': 17.317,
    'BE': 13.333
  },
  {
    'date': '2018-12-26 12:00:00',
    'datum': 1545822000000,
    'ZH': 21.72,
    'BS': 18.531,
    'BE': 12.488
  },
  {
    'date': '2018-12-26 13:00:00',
    'datum': 1545825600000,
    'ZH': 20.14,
    'BS': 20.374,
    'BE': 12.635
  },
  {
    'date': '2018-12-26 14:00:00',
    'datum': 1545829200000,
    'ZH': 20.18,
    'BS': 22.866,
    'BE': 14.253
  },
  {
    'date': '2018-12-26 15:00:00',
    'datum': 1545832800000,
    'ZH': 21.03,
    'BS': 22.006,
    'BE': 15.955
  },
  {
    'date': '2018-12-26 16:00:00',
    'datum': 1545836400000,
    'ZH': 21.03,
    'BS': 20.343,
    'BE': 16.289
  },
  {
    'date': '2018-12-26 17:00:00',
    'datum': 1545840000000,
    'ZH': 21.49,
    'BS': 20.513,
    'BE': 14.054
  },
  {
    'date': '2018-12-26 18:00:00',
    'datum': 1545843600000,
    'ZH': 24.51,
    'BS': 23.545,
    'BE': 15.425
  },
  {
    'date': '2018-12-26 19:00:00',
    'datum': 1545847200000,
    'ZH': 26.5,
    'BS': 22.872,
    'BE': 21.336
  },
  {
    'date': '2018-12-26 20:00:00',
    'datum': 1545850800000,
    'ZH': 26.56,
    'BS': 24.233,
    'BE': 20.361
  },
  {
    'date': '2018-12-26 21:00:00',
    'datum': 1545854400000,
    'ZH': 26.36,
    'BS': 23.438,
    'BE': 23.031
  },
  {
    'date': '2018-12-26 22:00:00',
    'datum': 1545858000000,
    'ZH': 26.17,
    'BS': 23.754,
    'BE': 24.346
  },
  {
    'date': '2018-12-26 23:00:00',
    'datum': 1545861600000,
    'ZH': 25.28,
    'BS': 22.571,
    'BE': 20.699
  },
  {
    'date': '2018-12-27 00:00:00',
    'datum': 1545865200000,
    'ZH': 24.62,
    'BS': 21.809,
    'BE': 17.897
  },
  {
    'date': '2018-12-27 01:00:00',
    'datum': 1545868800000,
    'ZH': 24.87,
    'BS': 22.042,
    'BE': 16.174
  },
  {
    'date': '2018-12-27 02:00:00',
    'datum': 1545872400000,
    'ZH': 23.64,
    'BS': 21.695,
    'BE': 16.851
  },
  {
    'date': '2018-12-27 03:00:00',
    'datum': 1545876000000,
    'ZH': 23.53,
    'BS': 21.232,
    'BE': 14.826
  },
  {
    'date': '2018-12-27 04:00:00',
    'datum': 1545879600000,
    'ZH': 22.47,
    'BS': 21.133,
    'BE': 16.98
  },
  {
    'date': '2018-12-27 05:00:00',
    'datum': 1545883200000,
    'ZH': 22.91,
    'BS': 20.715,
    'BE': 17.697
  },
  {
    'date': '2018-12-27 06:00:00',
    'datum': 1545886800000,
    'ZH': 25.36,
    'BS': 20.796,
    'BE': 17.423
  },
  {
    'date': '2018-12-27 07:00:00',
    'datum': 1545890400000,
    'ZH': 25.45,
    'BS': 20.806,
    'BE': 17.09
  },
  {
    'date': '2018-12-27 08:00:00',
    'datum': 1545894000000,
    'ZH': 26.89,
    'BS': 20.593,
    'BE': 16.893
  },
  {
    'date': '2018-12-27 09:00:00',
    'datum': 1545897600000,
    'ZH': 29.13,
    'BS': 19.976,
    'BE': 16.556
  },
  {
    'date': '2018-12-27 10:00:00',
    'datum': 1545901200000,
    'ZH': 29.61,
    'BS': 19.534,
    'BE': 18.802
  },
  {
    'date': '2018-12-27 11:00:00',
    'datum': 1545904800000,
    'ZH': 30.19,
    'BS': 20.888,
    'BE': 20.434
  },
  {
    'date': '2018-12-27 12:00:00',
    'datum': 1545908400000,
    'ZH': 28.07,
    'BS': 20.338,
    'BE': 17.726
  },
  {
    'date': '2018-12-27 13:00:00',
    'datum': 1545912000000,
    'ZH': 28,
    'BS': 19.218,
    'BE': 16.596
  },
  {
    'date': '2018-12-27 14:00:00',
    'datum': 1545915600000,
    'ZH': 27.57,
    'BS': 19.372,
    'BE': 20.39
  },
  {
    'date': '2018-12-27 15:00:00',
    'datum': 1545919200000,
    'ZH': 23.71,
    'BS': 20.439,
    'BE': 25.469
  },
  {
    'date': '2018-12-27 16:00:00',
    'datum': 1545922800000,
    'ZH': 26,
    'BS': 20.526,
    'BE': 21.215
  },
  {
    'date': '2018-12-27 17:00:00',
    'datum': 1545926400000,
    'ZH': 23.42,
    'BS': 21.962,
    'BE': 19.108
  },
  {
    'date': '2018-12-27 18:00:00',
    'datum': 1545930000000,
    'ZH': 20.76,
    'BS': 22.536,
    'BE': 22.406
  },
  {
    'date': '2018-12-27 19:00:00',
    'datum': 1545933600000,
    'ZH': 20.87,
    'BS': 22.42,
    'BE': 24.5
  },
  {
    'date': '2018-12-27 20:00:00',
    'datum': 1545937200000,
    'ZH': 22.15,
    'BS': 22.429,
    'BE': 21.451
  },
  {
    'date': '2018-12-27 21:00:00',
    'datum': 1545940800000,
    'ZH': 22.63,
    'BS': 23.443,
    'BE': 23.017
  },
  {
    'date': '2018-12-27 22:00:00',
    'datum': 1545944400000,
    'ZH': 21.82,
    'BS': 23.341,
    'BE': 21.762
  },
  {
    'date': '2018-12-27 23:00:00',
    'datum': 1545948000000,
    'ZH': 23.44,
    'BS': 23.706,
    'BE': 19.089
  },
  {
    'date': '2018-12-28 00:00:00',
    'datum': 1545951600000,
    'ZH': 23.81,
    'BS': 23.341,
    'BE': 18.926
  },
  {
    'date': '2018-12-28 01:00:00',
    'datum': 1545955200000,
    'ZH': 21.22,
    'BS': 22.582,
    'BE': 17.767
  },
  {
    'date': '2018-12-28 02:00:00',
    'datum': 1545958800000,
    'ZH': 21.89,
    'BS': 22.036,
    'BE': 15.823
  },
  {
    'date': '2018-12-28 03:00:00',
    'datum': 1545962400000,
    'ZH': 22.51,
    'BS': 22.838,
    'BE': 15.677
  },
  {
    'date': '2018-12-28 04:00:00',
    'datum': 1545966000000,
    'ZH': 23.8,
    'BS': 22.705,
    'BE': 15.989
  },
  {
    'date': '2018-12-28 05:00:00',
    'datum': 1545969600000,
    'ZH': 21.28,
    'BS': 24.125,
    'BE': 13.582
  },
  {
    'date': '2018-12-28 06:00:00',
    'datum': 1545973200000,
    'ZH': 18.23,
    'BS': 24.198,
    'BE': 14.606
  },
  {
    'date': '2018-12-28 07:00:00',
    'datum': 1545976800000,
    'ZH': 20.59,
    'BS': 25.41,
    'BE': 13.99
  },
  {
    'date': '2018-12-28 08:00:00',
    'datum': 1545980400000,
    'ZH': 20.5,
    'BS': 25.197,
    'BE': 17.069
  },
  {
    'date': '2018-12-28 09:00:00',
    'datum': 1545984000000,
    'ZH': 20.85,
    'BS': 25.747,
    'BE': 18.63
  },
  {
    'date': '2018-12-28 10:00:00',
    'datum': 1545987600000,
    'ZH': 22.51,
    'BS': 22.524,
    'BE': 20.361
  },
  {
    'date': '2018-12-28 11:00:00',
    'datum': 1545991200000,
    'ZH': 25.73,
    'BS': 27.135,
    'BE': 18.658
  },
  {
    'date': '2018-12-28 12:00:00',
    'datum': 1545994800000,
    'ZH': 23.24,
    'BS': 27.666,
    'BE': 21.375
  }
]

let allData = []

export default class Linechart extends React.Component<Props, State> {
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      dataReady: false
    }
  }

  componentDidMount () {
    // Get the data right to be shown in the linechart component and so on, bru!
    // Seriously! Filthy bastard.
    // console.log(this.props.data)
    // Okay, let's start with Zurich then..
    let zurichData = []
    for (let i = 0; i < this.props.data.zurich.length; i++) {
      let actualData = this.props.data.zurich[i]
      let month = actualData[0].split('.')[1]
      let day = actualData[0].split('.')[0]
      let year = actualData[0].split('.')[2].split(' ')[0]
      let hour = actualData[0].split(' ')[1]
      let formattedDate = year + '-' + month + '-' + day + ' ' + hour + ':00'
      actualData[0] = formattedDate
      zurichData.push(actualData)
    }
    let berneData = []
    for (let i = 0; i < this.props.data.berne.length; i++) {
      let actualData = this.props.data.berne[i]
      berneData.push(actualData)
    }
    let baselData = []
    for (let i = 0; i < this.props.data.basel.length; i++) {
      let actualData = this.props.data.basel[i]
      baselData.push(actualData)
    }
    this.setState({
      zurich: zurichData,
      basel: baselData,
      berne: berneData
    })
    console.log('data')
    console.log(this.state.zurich, this.state.basel, this.state.berne)
    let firstDates = {
      zurich: new Date(zurichData[0][0]).getTime(),
      berne: new Date(this.props.data.berne[0][0]).getTime(),
      basel: new Date(this.props.data.basel[0][0]).getTime()
    }
    // Evaluate the first date that exists in all the three datasets..
    let firstSharedTimestamp = _.max(firstDates)
    let firstSharedDateTime = moment(firstSharedTimestamp).format('YYYY-MM-DD HH:mm:ss')
    console.log(moment(firstSharedTimestamp).format('YYYY-MM-DD HH:mm:ss'))
    let firstIndexZurich = _.findIndex(zurichData, d => d[0] === firstSharedDateTime)
    // let firstIndexBasel = _.findIndex(baselData, d => d[0] ===
    // firstSharedDateTime)
    // let firstIndexBerne = _.findIndex(berneData, d => d[0] ===
    // firstSharedDateTime)
    // console.log('Zurich: ' + firstIndexZurich + ' Basel: ' +
    // firstIndexBasel + ' Bern: ' + firstIndexBerne)
    let filteredZurich = _.rest(zurichData, firstIndexZurich + 1)
    let filteredBasel = baselData
    let filteredBerne = berneData
    for (let i = 0; i < filteredZurich.length; i++) {
      console.log(i)
      let matchingBasel = _.findIndex(filteredBasel, d => d[0] === filteredZurich[i][0])
      let matchingBerne = _.findIndex(filteredBerne, d => d[0] === filteredZurich[i][0])
      allData.push({
        date: filteredZurich[i][0],
        BS: matchingBasel >= 0 ? parseFloat(filteredBasel[matchingBasel][1]) : null,
        ZH: isNaN(parseFloat(filteredZurich[i][1])) ? null : parseFloat(filteredZurich[i][1]),
        BE: matchingBerne >= 0 ? parseFloat(filteredBerne[matchingBerne][1]) : null
      })
    }
    this.setState({
      data: allData,
      dataReady: true
    })
  }

  render () {
    console.log(this.state.data)
    function formatXAxis (tickItem) {
      return moment(tickItem).format('HH:mm')
    }
    function formatYAxis (tickItem) {
      return tickItem + 'µg/m³'
    }
    let dataSet = []
    if (this.state.dataReady) {
      dataSet = this.state.data
    } else {
      dataSet = staticData
    }
    return (
      <div style={{width: '100%'}}>
        {!this.state.dataReady &&
        <div className='ui segment'>
          <div className='ui active inverted dimmer'>
            <div className='ui text loader'>Lade Daten..</div>
          </div>
        </div>
        }
        <ResponsiveContainer
          width={'100%'}
          aspect={2.0/1.0}
        >
          <LineChart
            data={this.state.data}
          >
            <XAxis
              scale={'point'}
              dataKey={'date'}
              tickSize={6}
              tickFormatter={formatXAxis}
              tick={{
                fontSize: '12px'
              }}
            />
            <YAxis
              domain={[0, 'auto']}
              tickSize={6}
              tickFormatter={formatYAxis}
              tick={{
                fontSize: '12px'
              }}
            />
            <Tooltip
              wrapperStyle={{
                borderColor: 'white'
              }}
              itemStyle={{
                padding: 0
              }}
              contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
              labelStyle={{ fontWeight: 'bold', color: '#666666' }}
              labelFormatter={(value) => moment(value).format('DD.MM / ' +
                ' HH:mm')}
            />
            <CartesianGrid
              vertical={false}
              strokeDasharray='5 5'
            />
            {this.props.data.zurich !== [] &&
            <Line
              name={'Zürich'}
              type='monotone'
              dataKey='ZH'
              stroke='#00A1CA'
              dot={false}
              strokeWidth={1}
              connectNulls
            />
            }
            {this.props.data.basel !== [] &&
            <Line
              name={'Basel'}
              type='monotone'
              dataKey='BS'
              stroke='#FFCA18'
              dot={false}
              strokeWidth={1}
              connectNulls
            />
            }
            {this.props.data.berne !== [] &&
            <Line
              name={'Bern'}
              type='monotone'
              dataKey='BE'
              stroke='#E23C4E'
              dot={false}
              strokeWidth={1}
              connectNulls
            />
            }
            <ReferenceLine y={20} label={'Langzeit-Grenzwert'} stroke='#E23C4E' strokeDasharray='3 3' isAnimationActive={false} />
            <ReferenceLine y={50} label={'Kurzzeit-Grenzwert'} stroke='#AD427F' strokeDasharray='3 3' isAnimationActive={false} />
            <Legend
              verticalAlign={'bottom'}
              height={14}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    )
  }
}
